<ion-card style="margin-inline: 0px" class="py-4 px-4 text-left rounded-1">
  <div  class="font-Poppins flex justify-end items-center space-x-1 text-[#46a83d] cursor-pointer">
    <!-- <div  *ngIf="name=='hospitals'">
     <div  (click)="deleteAction(data, $event)" class="font-Poppins flex justify-end items-center space-x-1 text-[#c83131] cursor-pointer">
    </div> -->
     
       <ion-icon size="large" name="create-outline"></ion-icon>
     </div>
  <p *ngFor="let key of keys" class="my-1">
    <ion-label> {{ key }}: </ion-label>
    <ion-text>
      {{ data[key] }}
    </ion-text>
  </p>
</ion-card>
